import { MAIN_THEME } from '@styles';

import { makeStyles } from 'tss-react/mui';

export const useWidgetStyles = makeStyles({ name: 'PolicyWidgetStyles' })(
  () => ({
    container: { width: '100%' },
    section: { padding: '23px 0 25px' },
    fieldRow: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 23.7%)',
      gap: '10px 1.75%',
      alignItems: 'start'
    },
    halfFieldRow: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 48%)',
      gap: '10px 1.75%',
      alignItems: 'start'
    },
    fullFieldRow: { gridColumn: '1 / -1', width: '100%' },
    row5Field: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 23.7%)',
      gap: '10px 1.75%',
      alignItems: 'start'
    },
    labelHeader: {
      fontSize: `${MAIN_THEME.fontSize.sm} !important`,
      lineHeight: '16px !important',
      fontFamily: `${MAIN_THEME.font.medium} !important`
    }
  })
);
